import type { HermesMessage } from "./hermes-api";

const THINK_BLOCK_RE = /<think>([\s\S]*?)<\/think>/gi;
const UNCLOSED_THINK_RE = /<think>[\s\S]*$/i;

/** Strip closed and unclosed `<think>` blocks from assistant markdown. */
export function stripHermesThinkTags(content: string): string {
  return content
    .replace(THINK_BLOCK_RE, "")
    .replace(UNCLOSED_THINK_RE, "")
    .trim();
}

/** Collect thinking text from `<think>` tags in content (historical / fallback). */
export function parseHermesThinking(content: string): string {
  const parts: string[] = [];
  for (const match of content.matchAll(/<think>([\s\S]*?)<\/think>/gi)) {
    const body = match[1]?.trim();
    if (body) parts.push(body);
  }
  const withoutClosed = content.replace(/<think>[\s\S]*?<\/think>/gi, "");
  const unclosed = withoutClosed.match(/<think>([\s\S]*)$/i);
  if (unclosed?.[1]?.trim()) {
    parts.push(unclosed[1].trim());
  }
  return parts.join("\n\n");
}

export type HermesAssistantParts = {
  thinking: string;
  answer: string;
};

/**
 * Prefer `tool_payload.thinking` (streamer); fall back to content tags.
 * Always strip think tags from the answer shown in MessageResponse.
 */
export function hermesAssistantParts(message: HermesMessage): HermesAssistantParts {
  const rawContent = message.content ?? "";
  const payloadThinking =
    typeof message.tool_payload?.thinking === "string"
      ? message.tool_payload.thinking.trim()
      : "";
  const tagThinking = parseHermesThinking(rawContent);
  return {
    thinking: payloadThinking || tagThinking,
    answer: stripHermesThinkTags(rawContent),
  };
}
